import React from 'react';
import { Route, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
// import ga from 'react-ga';
import NeedSelectUserRole from './NeedSelectUserRole';
import { GET_AUTH } from '../../gql/auth';
import { PrivateComponent, PrivateComponentInProject } from 'components/auth';
import {
  NotAuthorised,
  NotAuthorisedInProject,
} from 'components/layout/ErrorPage';

const env = process.env.REACT_APP_ENV;
console.log(env);

const PrivateRoute = ({
  component: Component,
  expectedScopeType,
  expectedScopeTypeInProject,
  ...rest
}) => {
  const {
    data: {
      auth: { isLoggedIn, loading },
    },
  } = useQuery(GET_AUTH);
  const { pathname, search } = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        !isLoggedIn && !loading ? (
          <Redirect
            to={`/login?local=${
              env === 'DEVELOPMENT'
            }&redirect=${encodeURIComponent(pathname)}${search ?? ''}`}
          />
        ) : (
          !loading && (
            <NeedSelectUserRole>
              {expectedScopeType.length > 0 ? (
                <PrivateComponent
                  expectedScopeType={expectedScopeType}
                  renderDenied={<NotAuthorised />}
                  {...props}
                >
                  <Component {...props} />
                </PrivateComponent>
              ) : expectedScopeTypeInProject.length > 0 ? (
                <PrivateComponentInProject
                  expectedScopeType={expectedScopeTypeInProject}
                  render={<NotAuthorisedInProject />}
                  {...props}
                >
                  <Component {...props} />
                </PrivateComponentInProject>
              ) : (
                <Component {...props} />
              )}
            </NeedSelectUserRole>
          )
        )
      }
    />
  );
};

PrivateRoute.defaultProps = {
  expectedScopeType: [],
  expectedScopeTypeInProject: [],
};

PrivateRoute.propTypes = {
  expectedScopeType: PropTypes.array.isRequired,
  expectedScopeTypeInProject: PropTypes.array.isRequired,
};

export default PrivateRoute;
